import { useState } from 'react';
import * as LucideIcons from 'lucide-react';
import { Button } from '@/components/ui/button';
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from '@/components/ui/popover';
import { Input } from '@/components/ui/input';
import { ScrollArea } from '@/components/ui/scroll-area';

interface IconSelectorProps {
  value?: string;
  onChange: (value: string) => void;
}

const commonIcons = [
  'Server', 'Monitor', 'Laptop', 'Smartphone', 'Tablet',
  'HardDrive', 'Network', 'Printer', 'Router', 'Wifi',
  'Database', 'Cloud', 'Cpu', 'MemoryStick', 'PackageCheck',
  'Box', 'Package', 'Boxes', 'Cable', 'Plug',
  'MapPin', 'Building', 'Building2', 'Warehouse', 'Map',
];

export const IconSelector = ({ value, onChange }: IconSelectorProps) => {
  const [search, setSearch] = useState('');
  const [open, setOpen] = useState(false);

  const SelectedIcon = value ? (LucideIcons as any)[value] || LucideIcons.Package : LucideIcons.Package;

  const filteredIcons = search
    ? commonIcons.filter(icon => icon.toLowerCase().includes(search.toLowerCase()))
    : commonIcons;

  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <Button variant="outline" className="w-full justify-start">
          <SelectedIcon className="h-4 w-4 mr-2" />
          {value || 'Selecione um ícone'}
        </Button>
      </PopoverTrigger>
      <PopoverContent className="w-80">
        <Input
          placeholder="Buscar ícone..."
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          className="mb-2"
        />
        <ScrollArea className="h-64">
          <div className="grid grid-cols-4 gap-2">
            {filteredIcons.map((iconName) => {
              const Icon = (LucideIcons as any)[iconName];
              return (
                <Button
                  key={iconName}
                  variant={value === iconName ? 'default' : 'ghost'}
                  size="sm"
                  onClick={() => {
                    onChange(iconName);
                    setOpen(false);
                  }}
                  className="h-12"
                >
                  <Icon className="h-5 w-5" />
                </Button>
              );
            })}
          </div>
        </ScrollArea>
      </PopoverContent>
    </Popover>
  );
};
